import { SelectOption, makeIsAllowed } from '@kanda-libs/ks-component-ts';

export const SELF_EMPLOYED_PROPS = {
  typeOfBusiness: {
    label: 'Type of business',
    placeholder: 'Type of your business',
  },
  businessName: {
    label: 'Name of business',
    placeholder: 'Name of your business',
  },
  yearsSelfEmployed: {
    label: 'Years self employed',
    placeholder: 'Your years self employed',
    isAllowed: makeIsAllowed(0, 100),
  },
  selfEmployedType: {
    label: 'Employment type',
    placeholder: 'Select...',
    name: 'credit.employment_details.self_employed_details.self_employed_type',
  },
  monthlyIncome: {
    type: 'price',
    placeholder: '£0.00',
    icon: 'pound',
    iconVariant: 'dark',
    label: 'Monthly Income After Tax',
    symbol: '',
    name: 'credit.employment_details.self_employed_details.monthly_income_after_tax',
  },
};

export const EMPLOYMENT_TYPE_VALIDATION = {
  required: { value: true, message: 'Employment type is required.' },
};

export const EMPLOYMENT_TYPE_OPTIONS: SelectOption[] = [
  { name: 'Full Time', value: 'full_time' },
  { name: 'Part Time', value: 'part_time' },
];

export const MONTHLY_INCOME_VALIDATION = {
  required: { value: true, message: 'Monthly income after tax is required.' },
};
